import { Icon } from "@elaniintc/goes-design-system";
import type { ComponentProps, ReactNode } from "react";

export interface IDropdownListItem {
  value: string;
  label: string | ReactNode;
  icon?: ComponentProps<typeof Icon>;
  detail?: string;
  disabled?: boolean;
  type?: string;
  toggleSelection?: (value: IDropdownListItem) => void;
}

interface DropdownListItemProps extends IDropdownListItem {
  iconPosition: "left" | "right";
}

const DropdownListItem = ({
  iconPosition,
  toggleSelection,
  ...item
}: DropdownListItemProps) => {
  return (
    <div
      role="menuitem"
      className="rounded-lg cursor-pointer text-body relative flex items-center gap-2 py-2 px-3 text-sm outline-hidden select-none hover:bg-neutral-object-accent-silent focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
      onClick={() => {
        if (!item.disabled && toggleSelection) {
          toggleSelection(item);
        }
      }}
    >
      <div className="w-full flex items-center gap-3">
        {iconPosition?.toLowerCase() === "left" && item.icon && (
          <Icon {...item.icon} />
        )}
        <div className="w-full gap-2 truncate">
          <p
            className={`font-semibold text-body ${!item.detail ? "truncate" : ""}`}
          >
            {item.label}
          </p>
          <span className="font-normal text-body-quiet truncate">
            {item.detail}
          </span>
        </div>
        {iconPosition?.toLowerCase() === "right" && item.icon && (
          <Icon {...item.icon} />
        )}
      </div>
    </div>
  );
};

export { DropdownListItem };
